/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { RefundOption } from 'app/shared/enumeration/refund-option';
import { RefundType } from 'app/shared/enumeration/refund-type';

export interface RefundTicketPriceType {
	id: number;
	name: string;
	amount: number;
}

@Component({
	selector: 'refund-ticket-price-type-list',
	templateUrl: './refund-ticket-price-type-list.component.html',
	styleUrls: ['./refund-ticket-price-type-list.component.scss'],
	standalone: false,
})
export class RefundTicketPriceTypeListComponent implements OnInit {
	ngOnInit(): void {
		this.disableControlsIfCustomerRefundType();
	}
	@Input() ticketsFormArray!: FormArray;
	@Input() refundTypeLookupData: any[] = [];

	displayedColumns: string[] = [
		'ticketType',
		'ticketNumber',
		'ticketPrice',
		'ticketPricePaid',
		'ticketRefundType',
		'bookingFee',
		'bookingFeePaid',
		'bookingFeeRefundType',
		'venueLevy',
		'venueLevyPaid',
		'venueLevyFeeRefundType',
		'paymentStatus',
		'ticketStatus',
		'dispatchStatus',
	];

	setRefundTypeControls(refundType: RefundType) {
		this.ticketsFormArray.controls.forEach((ticketGroup) => {
			const refundTypeControl = ticketGroup.get('ticketRefundType');
			const bookingFeeRefundTypeControl = ticketGroup.get('bookingFeeRefundType');
			const venueLevyFeeRefundTypeControl = ticketGroup.get('venueLevyFeeRefundType');

			if (refundTypeControl && refundTypeControl.enabled) {
				refundTypeControl.setValue(refundType);
			}
			if (bookingFeeRefundTypeControl && bookingFeeRefundTypeControl.enabled) {
				bookingFeeRefundTypeControl.setValue(refundType);
			}
			if (venueLevyFeeRefundTypeControl && venueLevyFeeRefundTypeControl.enabled) {
				venueLevyFeeRefundTypeControl.setValue(refundType);
			}
		});
	}
	disableControlsIfCustomerRefundType() {
		this.ticketsFormArray.controls.forEach((ticketGroup) => {
			const refundTypeControl = ticketGroup.get('ticketRefundType');
			const bookingFeeRefundTypeControl = ticketGroup.get('bookingFeeRefundType');
			const venueLevyFeeRefundTypeControl = ticketGroup.get('venueLevyFeeRefundType');

			if (refundTypeControl?.value === RefundType.Customer || refundTypeControl?.value === RefundType.Retained) {
				refundTypeControl.disable();
			}
			if (bookingFeeRefundTypeControl?.value === RefundType.Customer || bookingFeeRefundTypeControl?.value === RefundType.Retained) {
				bookingFeeRefundTypeControl.disable();
			}
			if (venueLevyFeeRefundTypeControl?.value === RefundType.Customer || venueLevyFeeRefundTypeControl?.value === RefundType.Retained) {
				venueLevyFeeRefundTypeControl.disable();
			}
		});
	}
	getTotals(): { [key: string]: number } {
		const totals = {
			ticketPrice: 0,
			ticketPricePaid: 0,
			bookingFee: 0,
			bookingFeePaid: 0,
			venueLevy: 0,
			venueLevyPaid: 0,
		};

		this.ticketsFormArray.controls.forEach((group: FormGroup) => {
			totals.ticketPrice += Number(group.value.ticketPrice) || 0;
			totals.ticketPricePaid += Number(group.value.ticketPricePaid) || 0;
			totals.bookingFee += Number(group.value.bookingFee) || 0;
			totals.bookingFeePaid += Number(group.value.bookingFeePaid) || 0;
			totals.venueLevy += Number(group.value.venueLevy) || 0;
			totals.venueLevyPaid += Number(group.value.venueLevyPaid) || 0;
		});

		return totals;
	}
}
